// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__7TARR","col":"styles_col__1kJDl"};